import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editIconLabel: {
		id: 'navigation-apps-sidebar-inline-config-project-header.editable-avatar.edit-icon-label',
		defaultMessage: 'Edit project icon',
		description:
			'The text is shown at the label for edit project icon button on inline configurable project header on side nav bar.',
	},
});
